import axiosInstance from "../../components/api/axiosInstance";

const unwrap = (res) => res.data?.data;
const base = "/client/billing";

/** Invoices this company raises to its own clients, and the payments it receives. */
const billingApi = {
  meta: () => axiosInstance.get(`${base}/meta`).then(unwrap),
  summary: () => axiosInstance.get(`${base}/summary`).then(unwrap),
  settings: () => axiosInstance.get(`${base}/settings`).then(unwrap),
  saveSettings: (body) => axiosInstance.put(`${base}/settings`, body).then(unwrap),
  invoices: (params) => axiosInstance.get(`${base}/invoices`, { params }).then(unwrap),
  invoice: (id) => axiosInstance.get(`${base}/invoices/${id}`).then(unwrap),
  createInvoice: (body) => axiosInstance.post(`${base}/invoices`, body).then(unwrap),
  updateInvoice: (id, body) => axiosInstance.put(`${base}/invoices/${id}`, body).then(unwrap),
  deleteInvoice: (id) => axiosInstance.delete(`${base}/invoices/${id}`).then(unwrap),
  issueInvoice: (id) => axiosInstance.post(`${base}/invoices/${id}/issue`).then(unwrap),
  cancelInvoice: (id, reason) => axiosInstance.post(`${base}/invoices/${id}/cancel`, { reason }).then(unwrap),
  duplicateInvoice: (id) => axiosInstance.post(`${base}/invoices/${id}/duplicate`).then(unwrap),
  sendInvoice: (id, body) => axiosInstance.post(`${base}/invoices/${id}/send`, body).then(unwrap),
  recordPayment: (id, body) => axiosInstance.post(`${base}/invoices/${id}/payments`, body).then(unwrap),
  payments: (params) => axiosInstance.get(`${base}/payments`, { params }).then(unwrap),
  cancelPayment: (id) => axiosInstance.post(`${base}/payments/${id}/cancel`).then(unwrap),
  clientStatement: (clientId) => axiosInstance.get(`${base}/clients/${clientId}/statement`).then(unwrap),
};

export default billingApi;

export function billingError(err, fallback = "Something went wrong") {
  return err?.response?.data?.message || fallback;
}
